module.exports = __webpack_public_path__ + "media/images/recruit/common/icon-wantedly-8a116fae476128df1b8d935fea446217.svg";